const shadows = {
    base: '0 1px 6px 0 rgba(0, 0, 0, 0.1)',
    hover: '0 3px 6px 0 rgba(0, 0, 0, 0.25)',
    around: '0 0 10px rgba(0, 0, 0, 0.6)',
    light: '0 1px 6px 0 rgba(0, 0, 0, 0.1)',
    button: 'none',
};
export default shadows;
//# sourceMappingURL=shadows.js.map